import { TimePicker } from '@material-ui/pickers'
import { useState, useEffect } from 'react'
import { getCurrentLanguage } from '../../../translations/i18n'
import { formatDateToMinutePrecision } from '../../../utils/dates'

const cancelLabel = {
  en: 'cancel',
  fi: 'peruuta'
}

const ReduxTimePickerWithoutKeyboard = ({
  input,
  label,
  meta,
  ...custom
}: any) => {
  const { value, onChange, onBlur } = input
  const { touched, invalid, error, active } = meta
  const [locale, setLocale] = useState<string>(getCurrentLanguage())
  useEffect(() => {
    const currentLocale = getCurrentLanguage()
    setLocale(currentLocale)
  }, [locale, setLocale])

  return (
    <TimePicker
      ampm={false}
      label={label}
      format='HH.mm'
      mask={'__.__'}
      cancelLabel={cancelLabel[locale]}
      error={invalid && touched && !active}
      value={value || null}
      {...custom}
      onBlur={() => onBlur()}
      helperText={touched && !active && error ? error : custom.helperText}
      onOpen={() => onBlur()}
      onChange={(newValue) => onChange(formatDateToMinutePrecision(newValue))}
      style={{ padding: '0' }}
      {...custom}
    />
  )
}

export default ReduxTimePickerWithoutKeyboard
